import Box from '@mui/material/Box';
import Head from "next/head";
import Typography from "@mui/material/Typography";


export default function ThankYouContactingBaywoodGreens() {
  return (
    <>
      <Head>
      <title>Thank you for reaching out | Baywood Greens</title>
        <meta name="description" content="Thank you for contacting us."/>
        <meta name={`robots`} content={`nofollow, noindex, noarchive, nosnippet, noodp, noydir, noimageindex, notranslate`}/>
      </Head>
      <Box my={5}>
        <Typography variant="h1" className={`page-title`}>THANK YOU FOR REACHING OUT TO BAYWOOD GREENS</Typography>
        <br/><br/>
        <Typography variant="h6">We will get in touch with you as soon as possible.</Typography>
        <br/><br/>
      </Box>
    </>
  );
}
